const API = "https://cristolive.org/api/";

export default API;
